"use client";

import { useState, useEffect } from "react";
import { ChevronDown } from "lucide-react";
import Navbar from "./components/navbar";
import FeaturesSection from "./components/features-section";
import HighlightSection from "./components/highlight-section";
import Footer from "./components/footer";
import { isMobile } from "react-device-detect";
import { AnimatePresence, motion } from "framer-motion";

export const MountainOfMadness = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "What is Mountain of Madness?",
      answer:
        "Mountain of Madness is Asia's first snow festival combining skiing/snowboarding, music, and community events at Yunding Ski Resort in Beijing. It's a 5-day adventure from December 13-17 featuring slopes, music stages, and exclusive social events.",
    },
    {
      question: "Do I need to know how to ski or snowboard?",
      answer:
        "Not at all! We welcome all skill levels from complete beginners to advanced riders. We offer lessons packages with accredited instructors for beginners, and the resort has slopes suitable for all levels.",
    },
    {
      question: "What's included in the package?",
      answer:
        "The package includes accommodation at Taizi Apartment or Hotel with breakfast, 3-day ski pass and equipment rentals, direct bus transfers from Beijing airports, access to all Mountain of Madness events and stages, and our community activities. Flight tickets are not included but can be added on for Singapore residents.",
    },
    {
      question: "Tell me more about the Slumber Party flight",
      answer:
        "The Slumber Party flight is our exclusive chartered flight from Singapore to Beijing, turning the journey into part of the adventure! It includes limited edition SoFlyer merch, and for Business Class, you'll get S$88 Sotravel Credit back. This is only available for Singapore residents as an add-on.",
    },
    {
      question: "Can I buy only one-way on the chartered flight?",
      answer: "No, you have to buy both ways.",
    },
    {
      question: "What kind of music will be played?",
      answer:
        "We'll feature 5 rising DJs from across Asia playing across two stages - the Top-of-the-world day stage and the MOM night stage. Expect a mix of electronic, dance, and party music to keep the energy high both on the slopes and after dark.",
    },
    {
      question: "How do I get to Yunding Ski Resort?",
      answer:
        "Direct bus transfers from Beijing Capital International Airport (PEK) and Daxing Airport are included in your package. The scenic journey takes about 3 hours and passes by the Great Wall of China!",
    },
    {
      question: "What should I pack?",
      answer:
        "Pack ski winter clothing, including thermal layers, waterproof outerwear, gloves, and a beanie. Ski/snowboard equipment is provided, but you may want to bring your own if you have specific preferences. Don't forget swimwear for the onsens, party outfits for the events, and your pajamas for the Slumber Party flight if you're joining from Singapore! A detailed packing list can be found after booking the trip on our app!",
    },
  ];

  const repeatWords = [
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
    "SNOW • MUSIC • ADVENTURE",
  ];

  const oldHighlights = [
    {
      title: "The Snow",
      image:
        "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/230534820250514-172813.png",
      description:
        "Whether you're a seasoned skier or finding your footing, Beijing has something for everyone. Boasting Asia's largest skiable glacier and an impressive network of pistes, the resort's altitude ensures superb snow-sport conditions.",
      cta: "EXPLORE THE SLOPES",
      color: "blue",
    },
    {
      title: "The Music",
      image:
        "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/176260720250514-172821.png",
      description:
        "SoFest is where borders disappear and friendships form. With a diverse lineup of artists from Singapore, Taiwan, Korea, and Japan—all performing on stunning stages set against the breathtaking backdrop of the mountains.",
      cta: "DISCOVER THE LINEUP",
      color: "yellow",
    },
    {
      title: "The Community",
      image:
        "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/172341320250514-172826.png",
      description:
        "Beyond the slopes, our vibrant community comes together for unforgettable experiences - from cozy fireside gatherings to exhilarating night events. Come create connections and memories that last long after the snow melts.",
      cta: "SEE ACTIVITIES",
      color: "red",
    },
  ];

  const highlights1 = [
    {
      title: "Slumber Party in the Air",
      image: "https://d1puf2nnbcyl9q.cloudfront.net/sofest-mom-15.png",
      description:
        "Never miss a beat! We'll be flying to the mountains in style with Air Sotravel- a slumber party dedicated to give you maximum vibes before the main event. Return tickets are available as an add-on only for those living in Singapore.",
      cta: "BOOK YOUR FLIGHT",
      color: "purple",
    },
    {
      title: "The Snow",
      image: "https://d1puf2nnbcyl9q.cloudfront.net/sofest-mom-2.png",
      description:
        "Experience the 2022 Winter Olympics venue in style as you bomb down 16km of runs, spread over 42 slopes. For those looking to pick up the sport or simply level up, the snow cannons do a great job of ensuring the pow all season long.",
      cta: "EXPLORE THE SLOPES",
      color: "blue",
    },
    {
      title: "The Music",
      image: "https://d1puf2nnbcyl9q.cloudfront.net/sofest-mom-17.png",
      description:
        "The beat never stops from day to night! Need a mid afternoon break? Head to our Apres Stage at the top of the mountain! Then end your night with a bang as our rising DJs from all across Asia keep the music going at the Main Stage. Before we do it all again the next day.",
      cta: "DISCOVER THE LINEUP",
      color: "yellow",
    },
    {
      title: "The Community",
      image: "https://d1puf2nnbcyl9q.cloudfront.net/sofest-mom-22.png",
      description:
        "Party at the slopes with Asia's largest adventure travel community that orignated from Singapore and Taiwan, now open to the entire region. With exclusive games, events and giveaways, nothing is gonna stop you from finding your tribe.",
      cta: "JOIN THE COMMUNITY",
      color: "red",
    },
  ];

  const highlights2 = [
    {
      title: "Your Stay",
      image: "https://d1puf2nnbcyl9q.cloudfront.net/sofest-mom-5.png",
      description:
        "Indulge in the Deluxe Rooms at the 3-Star Taizi Apartment or Hotel. It's ski in, ski out so you're ready to hit the slopes any time! FREE BREAKFAST INCLUDED!",
      cta: "VIEW ACCOMMODATIONS",
      color: "green",
    },
    {
      title: "Direct Transfer",
      image: "https://d1puf2nnbcyl9q.cloudfront.net/sofest-mom-6.png",
      description:
        "Enjoy direct bus transfers from PEK and Daxing airport, on a cozy 3 hours ride passing by the famed Great Wall of China!",
      cta: "TRANSFER DETAILS",
      color: "indigo",
    },
    {
      title: "Ski Pass + Rentals",
      image: "https://d1puf2nnbcyl9q.cloudfront.net/sofest-mom-7.png",
      description:
        "Ski pass and rentals for your skis, snowboard, boots and binding are included for 3 days. Those who do not require rentals can opt out.",
      cta: "EQUIPMENT INFO",
      color: "teal",
    },
    {
      title: "Instructions & Lessons",
      image: "https://d1puf2nnbcyl9q.cloudfront.net/sofest-mom-8.png",
      description:
        "Beginners can add on our lessons package by accredited snowboard and ski instructors. Lessons are held in groups of 4 for 1.5 days. Intermediates can opt in for advanced classes if they wish to level up their skills!",
      cta: "BOOK LESSONS",
      color: "orange",
    },
  ];

  const highlights3 = [
    {
      title: "The Slopes",
      image: "https://d1puf2nnbcyl9q.cloudfront.net/sofest-mom-16.png",
      description:
        "With 42km of slopes, an Olympic level halfpipe and a variey of park levels, you're bound to find adventure at every corner!",
      cta: "EXPLORE THE SLOPES",
      color: "blue",
    },
    {
      title: "Diverse Food Options",
      image: "https://d1puf2nnbcyl9q.cloudfront.net/sofest-mom-19.png",
      description:
        "More than 30+ restaurants and cafes to choose from including hotpot, KBBQ and traditional Chinese food!",
      cta: "VIEW DINING OPTIONS",
      color: "purple",
    },
    {
      title: "Never Get Bored!",
      image: "https://d1puf2nnbcyl9q.cloudfront.net/sofest-mom-18.png",
      description:
        "With a 24/7 indoor gym, onsens to relax and a Livehouse, you're spoilt for choice for post-slope activities!",
      cta: "DISCOVER ACTIVITIES",
      color: "pink",
    },
  ];

  const highlights4 = [
    {
      title: "So In Love - Winter Sonata",
      image: "https://d1puf2nnbcyl9q.cloudfront.net/sofest-mom-12.png",
      description:
        "You've felt the adrenaline on the slopes—now feel the spark off them. Join us for a game-filled night where the Top Couple can win $1,000 in prizes, including premium ski gears!",
      cta: "JOIN THE ROMANCE",
      color: "red",
    },
    {
      title: "SoTong Game - Snow Edition",
      image: "https://d1puf2nnbcyl9q.cloudfront.net/sofest-mom-13.png",
      description:
        "Come battle it out with strangers, where there can only be 1 winner. Stand a chance to win an epic reward of $3,000 in epic prizes up for grabs, including an Insta360 Action Camera!",
      cta: "BATTLE FOR PRIZES",
      color: "green",
    },
    {
      title: "SoMBTI - Friends Edition",
      image: "https://d1puf2nnbcyl9q.cloudfront.net/sofest-mom-14.png",
      description:
        "Guess the hidden MBTI in your group, make new friends and play wild chaotic, mini party games in this one-of-a-kind social mixer. 2 winners stand a chance to win $1000 prizes!",
      cta: "DISCOVER PERSONALITIES",
      color: "yellow",
    },
  ];

  return (
    <div className="tw-min-h-screen tw-bg-white">
      {/* Hero Section with Video Background */}
      <div className="tw-relative tw-h-screen tw-overflow-hidden">
        <div className="tw-absolute tw-inset-0 tw-z-0">
          {isMobile ? (
            <video
              className="tw-object-cover tw-w-full tw-h-full"
              autoPlay
              loop
              muted
              playsInline
            >
              <source
                src="https://d1puf2nnbcyl9q.cloudfront.net/MOM-landing-page-mobile.mov"
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
          ) : (
            <video
              className="tw-object-cover tw-w-full tw-h-full"
              autoPlay
              loop
              muted
              playsInline
            >
              <source
                src="https://d1puf2nnbcyl9q.cloudfront.net/MOM-landing-page-vid.mp4"
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
          )}
        </div>

        <div className="tw-absolute tw-inset-0 tw-bg-black tw-bg-opacity-10 tw-z-10"></div>

        <Navbar />

        <div className="tw-relative tw-z-20 tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full tw-text-white tw-px-4 tw-text-center">
          <img
            src="/images/MOM-logo.png"
            alt="SoFest Logo"
            className="tw-w-64 md:tw-w-80 tw-mb-6"
          />

          <p className="tw-text-xl md:tw-text-2xl tw-max-w-3xl tw-mb-10">
            Kick off your 25/26 winter season with an action packed week of
            snow, sound and social!
          </p>
          <p className="tw-text-xl md:tw-text-2xl tw-max-w-3xl tw-mb-8 tw-mt-3 tw-font-bold">
            13-17 Dec: Yunding Ski Resort, Beijing
          </p>
          <button
            onClick={() =>
              window.open("https://sotravel.com/trip/1948", "_blank")
            }
            className="tw-bg-[deepskyblue] tw-text-white tw-font-bold tw-py-3 tw-px-8 tw-rounded-md tw-text-lg hover:tw-bg-[steelblue] tw-transition-colors"
          >
            BOOK NOW
          </button>

          <div className="tw-absolute tw-bottom-8 tw-animate-bounce">
            <ChevronDown size={32} />
          </div>
        </div>
      </div>

      {/* Experience Section */}
      <section className="tw-py-20 tw-px-4 tw-bg-white">
        <div className="tw-w-[85vw] tw-mx-auto tw-text-center">
          <h2 className="tw-text-4xl md:tw-text-5xl tw-font-bold tw-mb-6">
            What's up in the mountains?
          </h2>
          <p className="tw-text-4xl tw-text-gray-700 tw-max-w-4xl tw-mx-auto tw-mb-10">
            Ready for the madness?
          </p>
          <HighlightSection highlights={highlights1} />
          <button
            onClick={() =>
              window.open("https://sotravel.com/trip/1948", "_blank")
            }
            className="tw-bg-[deepskyblue] tw-text-white tw-font-bold tw-py-3 tw-px-8 tw-rounded-md tw-text-lg hover:tw-bg-[steelblue] tw-transition-colors tw-mt-10"
          >
            LET'S GO
          </button>
        </div>
      </section>

      <section className="tw-py-20 tw-px-4 tw-bg-gray-50">
        <div className="tw-w-[95vw] md:tw-w-[85vw] tw-mx-auto tw-text-center">
          <h2 className="tw-text-4xl md:tw-text-5xl tw-font-bold tw-mb-6">
            Our playground
          </h2>
          <p className="tw-text-4xl tw-text-gray-700 tw-max-w-4xl tw-mx-auto tw-mb-10">
            Exclusive Resort Partner, Secret Garden Yunding
          </p>
          <FeaturesSection features={highlights3} maxHeight="20rem" />
        </div>
      </section>

      <section className="tw-py-10 tw-bg-[#00bfff] tw-overflow-hidden">
        <div className="tw-relative tw-flex tw-overflow-hidden">
          <div className="tw-flex tw-whitespace-nowrap tw-animate-marquee">
            {repeatWords.map((press, index) => (
              <div
                key={`first-${index}`}
                className="tw-text-white tw-font-bold tw-text-2xl md:tw-text-3xl tw-mx-12"
              >
                {press}
              </div>
            ))}
          </div>
          <div className="tw-flex tw-whitespace-nowrap tw-animate-marquee2">
            {repeatWords.map((press, index) => (
              <div
                key={`second-${index}`}
                className="tw-text-white tw-font-bold tw-text-2xl md:tw-text-3xl tw-mx-12"
              >
                {press}
              </div>
            ))}
          </div>
        </div>
        <style jsx>{`
          @keyframes marquee {
            0% {
              transform: translateX(0%);
            }
            100% {
              transform: translateX(-100%);
            }
          }
          @keyframes marquee2 {
            0% {
              transform: translateX(100%);
            }
            100% {
              transform: translateX(0%);
            }
          }
          .tw-animate-marquee {
            animation: marquee 420s linear infinite;
          }
          .tw-animate-marquee2 {
            animation: marquee2 420s linear infinite;
          }
          @media (max-width: 768px) {
            .tw-animate-marquee {
              animation: marquee 420s linear infinite;
            }
            .tw-animate-marquee2 {
              animation: marquee2 420s linear infinite;
            }
          }
        `}</style>
      </section>

      <section className="tw-py-20 tw-px-4 tw-bg-white">
        <div className="tw-w-[85vw] tw-mx-auto tw-text-center">
          <h2 className="tw-text-4xl md:tw-text-5xl tw-font-bold tw-mb-6">
            Mountains of Madness Package
          </h2>
          <p className="tw-text-4xl tw-text-gray-700 tw-max-w-4xl tw-mx-auto tw-mb-10">
            All inclusive, simply turn up and ride!
          </p>
          <HighlightSection highlights={highlights2} />
          <button
            onClick={() =>
              window.open("https://sotravel.com/trip/1948", "_blank")
            }
            className="tw-bg-[deepskyblue] tw-text-white tw-font-bold tw-py-3 tw-px-8 tw-rounded-md tw-text-lg hover:tw-bg-[steelblue] tw-transition-colors tw-mt-0"
          >
            BOOK NOW
          </button>
        </div>
      </section>

      <section className="tw-py-18 tw-px-4 tw-bg-gray-50">
        <div className="tw-w-[95vw] md:tw-w-[85vw] tw-mx-auto tw-text-center">
          <h2 className="tw-text-4xl md:tw-text-5xl tw-font-bold tw-mb-6">
            One-of-a-kind Events!
          </h2>
          <p className="tw-text-4xl tw-text-gray-700 tw-max-w-4xl tw-mx-auto tw-mb-10">
            Our community events' greatest hits{" "}
          </p>
          <FeaturesSection features={highlights4} maxHeight="30rem" />
        </div>
      </section>

      <section className="tw-py-10 tw-bg-[#00bfff] tw-overflow-hidden">
        <div className="tw-relative tw-flex tw-overflow-hidden">
          <div className="tw-flex tw-whitespace-nowrap tw-animate-marquee">
            {repeatWords.map((press, index) => (
              <div
                key={`first-${index}`}
                className="tw-text-white tw-font-bold tw-text-2xl md:tw-text-3xl tw-mx-12"
              >
                {press}
              </div>
            ))}
          </div>
          <div className="tw-flex tw-whitespace-nowrap tw-animate-marquee2">
            {repeatWords.map((press, index) => (
              <div
                key={`second-${index}`}
                className="tw-text-white tw-font-bold tw-text-2xl md:tw-text-3xl tw-mx-12"
              >
                {press}
              </div>
            ))}
          </div>
        </div>
        <style jsx>{`
          @keyframes marquee {
            0% {
              transform: translateX(0%);
            }
            100% {
              transform: translateX(-100%);
            }
          }
          @keyframes marquee2 {
            0% {
              transform: translateX(100%);
            }
            100% {
              transform: translateX(0%);
            }
          }
          .tw-animate-marquee {
            animation: marquee 420s linear infinite;
          }
          .tw-animate-marquee2 {
            animation: marquee2 420s linear infinite;
          }
          @media (max-width: 768px) {
            .tw-animate-marquee {
              animation: marquee 420s linear infinite;
            }
            .tw-animate-marquee2 {
              animation: marquee2 420s linear infinite;
            }
          }
        `}</style>
      </section>

      {/* Slumber Party in the Air Section */}
      <section className="tw-py-20 tw-px-4 tw-bg-gray-50">
        <div className="tw-max-w-7xl tw-mx-auto">
          <div className="tw-text-center tw-mb-12">
            <h2 className="tw-text-4xl md:tw-text-5xl tw-font-bold tw-mb-6">
              Slumber Party in the Air!
            </h2>
            <p className="tw-text-xl tw-text-gray-700 tw-max-w-3xl tw-mx-auto">
              Welcome aboard Sotravel Air
            </p>
          </div>

          <div className="tw-flex tw-flex-col md:tw-flex-row tw-items-center tw-justify-center tw-gap-8">
            <div className="tw-w-full md:tw-w-1/3">
              <img
                src="https://d1puf2nnbcyl9q.cloudfront.net/sofest-mom-20.png"
                alt="Sotravel Air Slumber Party"
                className="tw-rounded-lg tw-shadow-lg tw-w-full"
              />
              <p className="tw-text-sm tw-text-gray-500 tw-mt-2 tw-text-center">
                *Slumber party crew for illustrative purposes, not actual photos
                of the plane
              </p>
            </div>

            <div className="tw-w-full md:tw-w-1/2">
              <div className="tw-rounded-lg tw-p-8">
                <p className="tw-mb-4 tw-text-lg">
                  Hop on our <span className="tw-font-bold">one and only</span>{" "}
                  private Sotravel Airlines flight to Beijing—where the party
                  starts early with mid-air turbulence (aka a wild plane party)!
                </p>
                <p className="tw-mb-6 tw-text-lg">
                  Dress code - "your jammies."
                </p>

                <div className="tw-mb-8">
                  <h3 className="tw-text-2xl tw-font-bold tw-mb-4">
                    Economy Class
                  </h3>
                  <ul className="tw-list-disc tw-pl-5 tw-space-y-2">
                    <li>Exclusive limited edition SoFlyer Merch</li>
                    <li>
                      Only 180 spots available!{" "}
                      <span className="tw-italic tw-font-semibold">
                        Selling Fast
                      </span>
                    </li>
                  </ul>
                </div>

                <div>
                  <h3 className="tw-text-2xl tw-font-bold tw-mb-4">
                    Business Class,
                  </h3>
                  <ul className="tw-list-disc tw-pl-5 tw-space-y-2">
                    <li>Get S$88 Sotravel Credit Back!</li>
                    <li>Exclusive limited edition SoFlyer VIP Merch</li>
                    <li>Only 12 spots available.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Music Lineup Section */}
      <section
        className="tw-py-20 tw-px-4 tw-bg-gray-100"
        style={{
          backgroundImage:
            'url(\'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" opacity="0.1"><text x="0" y="20" font-family="Arial" font-size="20" fill="black" transform="rotate(45 100,100)">MUSIC MUSIC MUSIC</text><text x="40" y="60" font-family="Arial" font-size="20" fill="black" transform="rotate(45 100,100)">MUSIC MUSIC MUSIC</text><text x="80" y="100" font-family="Arial" font-size="20" fill="black" transform="rotate(45 100,100)">MUSIC MUSIC MUSIC</text><text x="120" y="140" font-family="Arial" font-size="20" fill="black" transform="rotate(45 100,100)">MUSIC MUSIC MUSIC</text><text x="160" y="180" font-family="Arial" font-size="20" fill="black" transform="rotate(45 100,100)">MUSIC MUSIC MUSIC</text></svg>\')',
          backgroundRepeat: "repeat",
        }}
      >
        <div className="tw-max-w-6xl tw-mx-auto">
          <h2 className="tw-text-4xl md:tw-text-5xl tw-font-bold tw-mb-4 tw-text-center">
            Party in the slopes
          </h2>
          <h3 className="tw-text-2xl md:tw-text-2xl tw-font-bold tw-mb-2 tw-text-center">
            2 Stages
          </h3>
          <h3 className="tw-text-2xl md:tw-text-2xl tw-font-bold tw-mb-2 tw-text-center">
            5 Rising DJs from Asia
          </h3>

          <div className="tw-flex tw-flex-col md:tw-flex-row tw-items-center tw-justify-center tw-gap-0 tw-mt-12">
            <div className="tw-w-full md:tw-w-1/4 tw-space-y-4 tw-text-center md:tw-text-left">
              <div className="tw-mt-6 tw-space-y-4">
                <div>
                  <p className="tw-text-xl tw-font-bold">14 Dec</p>
                  <p className="tw-text-lg">Mountaintop Day Stage</p>
                  <p className="tw-text-lg">Madness Night Stage</p>
                </div>

                <div className="tw-mt-4">
                  <p className="tw-text-xl tw-font-bold">15 Dec</p>
                  <p className="tw-text-lg">Mountaintop Day Stage</p>
                </div>

                <p className="tw-text-lg tw-font-bold tw-mt-6">
                  DJ LINEUP COMING SOON!
                </p>
              </div>
            </div>
            <div className="tw-w-full md:tw-w-3/5">
              <div className="tw-grid tw-grid-cols-3 tw-gap-2 tw-transform tw-rotate-1">
                <div className="tw-aspect-square tw-overflow-hidden">
                  <img
                    src="https://d1puf2nnbcyl9q.cloudfront.net/sofest-mom-17.png"
                    alt="Party crowd at Mountain of Madness"
                    className="tw-rounded-lg tw-shadow-lg tw-w-full tw-h-full tw-object-cover tw-transform tw-rotate-2 hover:tw-scale-110 tw-transition-transform"
                  />
                </div>
                <div className="tw-aspect-square tw-overflow-hidden">
                  <img
                    src="https://d1puf2nnbcyl9q.cloudfront.net/sofest-mom-23.png"
                    alt="Party crowd at Mountain of Madness"
                    className="tw-rounded-lg tw-shadow-lg tw-w-full tw-h-full tw-object-cover tw-transform -tw-rotate-3 hover:tw-scale-110 tw-transition-transform"
                  />
                </div>
                <div className="tw-aspect-square tw-overflow-hidden">
                  <img
                    src="https://d1puf2nnbcyl9q.cloudfront.net/sofest-mom-21.png"
                    alt="Party crowd at Mountain of Madness"
                    className="tw-rounded-lg tw-shadow-lg tw-w-full tw-h-full tw-object-cover tw-transform tw-rotate-1 hover:tw-scale-110 tw-transition-transform"
                  />
                </div>
                <div className="tw-aspect-square tw-overflow-hidden">
                  <img
                    src="https://d1puf2nnbcyl9q.cloudfront.net/sofest-mom-24.png"
                    alt="Party crowd at Mountain of Madness"
                    className="tw-rounded-lg tw-shadow-lg tw-w-full tw-h-full tw-object-cover tw-transform -tw-rotate-1 hover:tw-scale-110 tw-transition-transform"
                  />
                </div>
                <div className="tw-aspect-square tw-overflow-hidden">
                  <img
                    src="https://d1puf2nnbcyl9q.cloudfront.net/sofest-mom-30.png"
                    alt="Party crowd at Mountain of Madness"
                    className="tw-rounded-lg tw-shadow-lg tw-w-full tw-h-full tw-object-cover tw-transform tw-rotate-3 hover:tw-scale-110 tw-transition-transform"
                  />
                </div>
                <div className="tw-aspect-square tw-overflow-hidden">
                  <img
                    src="https://d1puf2nnbcyl9q.cloudfront.net/sofest-mom-31.png"
                    alt="Party crowd at Mountain of Madness"
                    className="tw-rounded-lg tw-shadow-lg tw-w-full tw-h-full tw-object-cover tw-transform -tw-rotate-2 hover:tw-scale-110 tw-transition-transform"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="tw-py-16 tw-px-4 tw-bg-white">
        <div className="tw-max-w-4xl tw-mx-auto tw-text-center">
          {/* <img
            src="https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/220411MOM-Poster.png"
            alt="SoFest - Ski. Sleep. Rave. Repeat."
            className="tw-w-64 tw-mx-auto tw-mb-8"
          /> */}

          <div className="tw-mb-10">
            <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-6">
              <div className="tw-w-4/5 tw-mx-auto tw-h-[480px] tw-overflow-hidden tw-rounded-lg tw-shadow-lg">
                <iframe
                  src="https://www.instagram.com/p/DJoVynUpseD/embed"
                  width="100%"
                  height="100%"
                  frameBorder="0"
                  scrolling="no"
                  allowTransparency="true"
                ></iframe>
              </div>
              <div className="tw-w-4/5 tw-mx-auto tw-h-[480px] tw-overflow-hidden tw-rounded-lg tw-shadow-lg">
                <iframe
                  src="https://www.instagram.com/p/DJ0kKchyQWq/embed"
                  width="100%"
                  height="100%"
                  frameBorder="0"
                  scrolling="no"
                  allowTransparency="true"
                ></iframe>
              </div>
            </div>
          </div>

          <h2 className="tw-text-3xl md:tw-text-4xl tw-font-bold tw-mb-6">
            Ready for the Mountain of Madness?
          </h2>
          <p className="tw-text-xl tw-text-gray-700 tw-mb-3">
            Sale spots up for grabs at $749!
          </p>
          <p className="tw-text-xl tw-text-gray-700 tw-mb-8">
            Original price of $849.
          </p>
          <button
            onClick={() =>
              window.open("https://sotravel.com/trip/1948", "_blank")
            }
            className="tw-bg-[deepskyblue] tw-text-white tw-font-bold tw-py-3 tw-px-8 tw-rounded-md tw-text-lg hover:tw-bg-[steelblue] tw-transition-colors"
          >
            BOOK NOW
          </button>
        </div>
      </section>

      <section className="tw-bg-white tw-py-2">
        <div className="tw-container tw-mx-auto tw-px-4 md:tw-px-16 lg:tw-px-24 tw-py-10 md:tw-py-10">
          <div className="tw-text-[26px] md:tw-text-[32px] tw-font-extrabold tw-text-center">
            Frequently Asked Questions
          </div>
          <div className="tw-text-base md:tw-text-lg tw-text-primary-main tw-text-center tw-font-semibold tw-mb-6 md:tw-mb-10">
            Everything you need to know about Mountain of Madness
          </div>
          <div className="md:tw-max-w-3xl md:tw-mx-auto">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className={`tw-border-b tw-border-x tw-border-[#E9ECEF] ${
                  index === faqs.length - 1
                    ? "tw-rounded-bl-lg tw-rounded-br-lg"
                    : ""
                } ${
                  index === 0 && "tw-rounded-tl-lg tw-rounded-tr-lg tw-border-t"
                }`}
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className={`tw-w-full tw-px-4 md:tw-px-6 tw-py-3 md:tw-py-4 tw-flex tw-items-center tw-gap-2 hover:tw-bg-[#F8F9FA] tw-transition-colors ${
                    openIndex === index ? "tw-bg-[#F8F9FA]" : ""
                  }`}
                >
                  <div className="tw-text-sm md:tw-text-base tw-grow tw-text-left">
                    {faq.question}
                  </div>
                  <motion.div
                    animate={{ rotate: openIndex === index ? 180 : 0 }}
                    transition={{ duration: 0.3 }}
                    className="tw-flex-none tw-text-[#CED4DA]"
                  >
                    <ChevronDown className="tw-w-5 tw-h-5 md:tw-w-6 md:tw-h-6" />
                  </motion.div>
                </button>
                <AnimatePresence>
                  {openIndex === index && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                      className="tw-overflow-hidden"
                    >
                      <div className="tw-px-4 md:tw-px-6 tw-py-3 md:tw-py-4 tw-border-t tw-border-[#E9ECEF] tw-bg-[#F8F9FA] tw-text-sm md:tw-text-base">
                        {faq.answer}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};
